// frontend/src/pages/ApplyPage.jsx

import React from 'react';
import Layout from '../components/layout/Layout';
import ApplicationForm from '../components/application/ApplicationForm';

const ApplyPage = () => {
  return (
    <Layout>
      <ApplicationForm />
    </Layout>
  );
};

export default ApplyPage;